import { render } from "./SchoolModal.vue?vue&type=template&id=0252d2a1"
import script from "./SchoolModal.vue?vue&type=script&lang=js"
export * from "./SchoolModal.vue?vue&type=script&lang=js"

import "./SchoolModal.vue?vue&type=style&index=0&id=0252d2a1&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__